<template>
  <div class="hello">
      <div class='container'>
            <transition name="fade">
                <div v-if="addingFile" class="loading">
                    <p>Uploading Image...</p>
                </div>
            </transition>
        </div>

        <!-- Error modal if not image type -->
        <b-modal id="modal-error" ok-only title="Error" ok-title="OK">
            {{errMsg}}
        </b-modal>

        <!-- Modal item added -->
        <b-modal id="modal-itemadded" ok-only title="Success" ok-title="OK" @ok="endAddItem">
            {{localSaleItem.title}} Updated
        </b-modal>

    <b-container>
        <b-row>
            <b-col>
                <h4 style="margin-top:20px">Update Your Item</h4>
            </b-col>
        </b-row>
        <!-- Title -->
        <b-row>
            <b-col>
                <b-input-group prepend="Title" class="mt-3">
                    <b-form-input v-model="localSaleItem.title" placeholder="Add a Title"></b-form-input>
                </b-input-group>
            </b-col>
        </b-row>

        <!-- Price -->
        <b-row>
            <b-col>
                <b-input-group prepend="Price $" class="mt-3">
                    <b-form-input v-model="localSaleItem.price" placeholder="Numbers Only"></b-form-input>
                </b-input-group>
            </b-col>
        </b-row>

        <!-- Description -->
        <b-row>
            <b-col>
                <b-form-group style="margin-top:20px" class="mb-0" label-for="textarea-formatter" description="Details of this item">
                    <b-form-textarea
                        id="textarea-formatter"
                        v-model="localSaleItem.description"
                        placeholder="Add a description"
                    ></b-form-textarea>
                </b-form-group>
            </b-col>
        </b-row>

        <!-- Images -->
        <b-row>
            <b-col>
                <h6 style="margin-top:20px">Add Up To 6 Images</h6>
            </b-col>
        </b-row>
        <!-- Logo -->
        <b-row>
                <!-- Image 1 -->
                <b-card style="width: 300px; margin:10px;">
                    <input id="image1"  @change="onLogoFileChanged($event, 'image1')"  type="file" hidden>
                    <div style="height:110px; text-align: center;  margin-bottom:10px">
                        <img v-if="localSaleItem.imageurl1" @click="chooseFiles($event, 'image1')" style="cursor: pointer" height="100px" :src="localSaleItem.imageurl1"/>
                        <img v-else @click="chooseFiles($event, 'image1')" style="cursor: pointer;; border:1px solid black" height="100px" src="../../assets/addalogo.png"/>
                    </div>
                    <!-- Delete image button -->
                    <div  v-if="localSaleItem.imageurl1"><b-button size="sm" variant="outline-danger" @click="deleteImage('image1')">Delete</b-button></div>
                </b-card>

                <!-- Image 2 -->
                <b-card style="width: 300px; margin:10px; ">
                    <input id="image2"  @change="onLogoFileChanged($event, 'image2')"  type="file" hidden>
                    <div style="height:110px; text-align: center;  margin-bottom:10px">
                        <img v-if="localSaleItem.imageurl2" @click="chooseFiles($event, 'image2')" style="cursor: pointer;" height="100px" :src="localSaleItem.imageurl2"/>
                        <img v-else @click="chooseFiles($event, 'image2')" style="cursor: pointer; border:1px solid black" height="100px" src="../../assets/addalogo.png"/>
                    </div>
                    <!-- Delete image button -->
                    <div  v-if="localSaleItem.imageurl2"><b-button size="sm" variant="outline-danger" @click="deleteImage('image2')">Delete</b-button></div>
                </b-card>

                <!-- Image 3 -->
                <b-card style="width: 300px; margin:10px; ">
                    <input id="image3"  @change="onLogoFileChanged($event, 'image3')"  type="file" hidden>
                    <div style="height:110px; text-align: center;  margin-bottom:10px">
                        <img v-if="localSaleItem.imageurl3" @click="chooseFiles($event, 'image3')" style="cursor: pointer;" height="100px" :src="localSaleItem.imageurl3"/>
                        <img v-else @click="chooseFiles($event, 'image3')" style="cursor: pointer; border:1px solid black" height="100px" src="../../assets/addalogo.png"/>
                    </div>
                    <!-- Delete image button -->
                    <div  v-if="localSaleItem.imageurl3"><b-button size="sm" variant="outline-danger" @click="deleteImage('image3')">Delete</b-button></div>
                </b-card>

                <!-- Image 4 -->
                <b-card style="width: 300px; margin:10px; ">
                    <input id="image4"  @change="onLogoFileChanged($event, 'image4')"  type="file" hidden>
                    <div style="height:110px; text-align: center;  margin-bottom:10px">
                        <img v-if="localSaleItem.imageurl4" @click="chooseFiles($event, 'image4')" style="cursor: pointer;" height="100px" :src="localSaleItem.imageurl4"/>
                        <img v-else @click="chooseFiles($event, 'image4')" style="cursor: pointer; border:1px solid black" height="100px" src="../../assets/addalogo.png"/>
                        <!-- Delete image button -->
                        <div  v-if="localSaleItem.imageurl4"><b-button size="sm" variant="outline-danger" @click="deleteImage('image4')">Delete</b-button></div>
                    </div>
                </b-card>

                <!-- Image 5 -->
                <b-card style="width: 300px; margin:10px; ">
                    <input id="image5"  @change="onLogoFileChanged($event, 'image5')"  type="file" hidden>
                    <div style="height:110px; text-align: center;  margin-bottom:10px">
                        <img v-if="localSaleItem.imageurl5" @click="chooseFiles($event, 'image5')" style="cursor: pointer;" height="100px" :src="localSaleItem.imageurl5"/>
                        <img v-else @click="chooseFiles($event, 'image5')" style="cursor: pointer; border:1px solid black" height="100px" src="../../assets/addalogo.png"/>
                    </div>
                    <!-- Delete image button -->
                    <div  v-if="localSaleItem.imageurl5"><b-button size="sm" variant="outline-danger" @click="deleteImage('image5')">Delete</b-button></div>
                </b-card>

                <!-- Image 6 -->
                <b-card style="width: 300px; margin:10px; ">
                    <input id="image6"  @change="onLogoFileChanged($event, 'image6')"  type="file" hidden>
                    <div style="height:110px; text-align: center;  margin-bottom:10px">
                        <img v-if="localSaleItem.imageurl6" @click="chooseFiles($event, 'image6')" style="cursor: pointer;" height="100px" :src="localSaleItem.imageurl6"/>
                        <img v-else @click="chooseFiles($event, 'image6')" style="cursor: pointer; border:1px solid black" height="100px" src="../../assets/addalogo.png"/>
                    </div>
                    <!-- Delete image button -->
                    <div  v-if="localSaleItem.imageurl6"><b-button size="sm" variant="outline-danger" @click="deleteImage('image6')">Delete</b-button></div>
                </b-card>
        </b-row>

        <!-- Add Item Button -->
        <b-row>
            <b-col>
                <!-- Update -->
                <b-button variant="success" @click="addItem(true)">Update</b-button>
                
                <!-- Mark Sold -->
                <b-button variant="info" style="margin-left:10px" v-if="!localSaleItem.sold"  v-b-modal.markSold>Mark Sold</b-button>
                <b-modal id="markSold" @ok="markSold(1)" ok-title="Yes, Mark Sold">
                    Mark Sold?
                </b-modal>

                <!-- Re-activate -->
                <b-modal id="modal-markavailable" @ok="markSold(0)" ok-title="Yes, Mark Available">
                    Mark Available?
                </b-modal>
                <b-button variant="info" style="margin-left:10px" v-if="localSaleItem.sold"  @click="showAvailableModal()">Mark Available</b-button>

                <!-- Cancel -->
                <b-button style="margin-left:10px"  @click="endAddItem()">Cancel</b-button>
            </b-col>
        </b-row>
        
    </b-container>
    <div id="footerid">
        <footer><pagefooter/></footer>
    </div>
      
  </div>
</template>

<script>

import { mapState } from 'vuex'
import Uploadimage from '../Uploadimage'
const fb = require('../../firebaseConfig.js')
import Pagefooter from '../Pagefooter'
import axios from 'axios'

export default {    
    props: ['saleItem'],

    computed: {
        ...mapState(['userProfileStatus', 'userProfile', 'currentUser'])
    },

    components: {
        Uploadimage,
        Pagefooter,
    },

    data() {
        return {
            errMsg:'',
            theItem:{},
            addingFile:false,
            cloudinary: {
                logoFullPreset:'forsalefullimage',
                logoThumbPreset:'forsalethumbnailimage',
                apiKey: '629997215451183',
                cloudName: 'lo4xxr5lr',
                uploadURL:'https://api.cloudinary.com/v1_1/lo4xxr5lr/upload'
            }, 
            localSaleItem:{},

        }
    },

    methods:{

        //Choose image files
        chooseFiles(event, imagenumber) {
            console.log("Choosing image")
            document.getElementById(imagenumber).click()
            
        },

        //Image file changed
        onLogoFileChanged (event, imagenumber) {
            console.log("File changed: " + imagenumber)
            this.selectedFile = event.target.files[0]
            const name = event.target.files[0].name;
            const lastDot = name.lastIndexOf('.');

            this.fileName = name.substring(0, lastDot);
            this.fileExtension = name.substring(lastDot + 1);

            console.log(this.fileName, this.fileExtension)

            //Check file extention
            this.fileExtension=this.fileExtension.toLowerCase()
            if(this.fileExtension!='jpg'&&this.fileExtension!='jpeg'&&this.fileExtension!='png'){
                this.errMsg="Image must be a JPEG or PNG"
                this.$bvModal.show("modal-error")
                return
            }
            this.uploadLogotoCloudinary(imagenumber)
        },

        //Upload file
        uploadLogotoCloudinary(imagenumber){
            this.addingFile = true
            let data = new FormData();
            data.append('file', this.selectedFile); 
            data.append('upload_preset', this.cloudinary.logoThumbPreset);

            axios
                .post(this.cloudinary.uploadURL, data)
                .then((result) => {
                    if(result.data.secure_url){
                        console.log("URL main: " + result.data.secure_url)
                        if(imagenumber=='image1') this.localSaleItem.imageurl1 = result.data.secure_url
                        else if(imagenumber=='image2') this.localSaleItem.imageurl2 = result.data.secure_url
                        else if(imagenumber=='image3') this.localSaleItem.imageurl3 = result.data.secure_url
                        else if(imagenumber=='image4') this.localSaleItem.imageurl4 = result.data.secure_url
                        else if(imagenumber=='image5') this.localSaleItem.imageurl5 = result.data.secure_url
                        else if(imagenumber=='image6') this.localSaleItem.imageurl6 = result.data.secure_url
                    }
                    this.addingFile = false

                })
                .catch((err) => {
                    console.log('Ax Error:' + err);
                    this.addingFile = false
                }) 

            let thumbdata = new FormData();
            thumbdata.append('file', this.selectedFile); 
            thumbdata.append('upload_preset', this.cloudinary.logoFullPreset);

            //Add thumbnail
            axios
                .post(this.cloudinary.uploadURL, thumbdata)
                .then((result) => {
                    if(result.data.secure_url){
                        console.log("URL thumbnail: " + result.data.secure_url)
                        //Add thumbnail url
                        if(imagenumber=='image1') this.localSaleItem.imagethumburl1 = result.data.secure_url
                        else if(imagenumber=='image2') this.localSaleItem.imagethumburl2 = result.data.secure_url
                        else if(imagenumber=='image3') this.localSaleItem.imagethumburl3 = result.data.secure_url
                        else if(imagenumber=='image4') this.localSaleItem.imagethumburl4 = result.data.secure_url
                        else if(imagenumber=='image5') this.localSaleItem.imagethumburl5 = result.data.secure_url
                        else if(imagenumber=='image6') this.localSaleItem.imagethumburl6 = result.data.secure_url
                    }
                    this.addingFile = false
                })
                .catch((err) => {
                    console.log('Ax Thumb Error:' + err);
                    this.addingFile = false
                })

            },

        //Update the item
        addItem(shouldClose){
            console.log("Adding Item with price " + this.localSaleItem.price)

            //Check for errors
            if(this.localSaleItem.title.length<4){
                this.errMsg="Enter at least 4 characters for the title"
                this.$bvModal.show("modal-error")
                return
            }
            if(isNaN(this.localSaleItem.price)||!this.localSaleItem.price){
                this.errMsg="Enter a valid price, numbers only"
                this.$bvModal.show("modal-error")
                return
            }
            if(this.localSaleItem.description.length<10){
                this.errMsg="Enter at least 10 characters for description"
                this.$bvModal.show("modal-error")
                return
            }

            var saleData=this.localSaleItem

            fb.forSaleCollection.doc(this.localSaleItem.docId).update(saleData)
            if(shouldClose) this.$bvModal.show("modal-itemadded")
        },

        //Mark item as sold
        markSold(val){
            fb.forSaleCollection.doc(this.localSaleItem.docId).update({active:!val, sold:val})
            this.$emit('closeManageItemModal', this.localSaleItem.id)
        },
        //Show mark available modal. Some bug.

        showAvailableModal(){
            this.$bvModal.show("modal-markavailable")
        },
        //End item and go back
        endAddItem(){
            this.$emit('closeManageItemModal', this.localSaleItem.id)
        },

        //Delete image
        deleteImage(imagenumber){
            if(imagenumber=='image1'){
                this.localSaleItem.imageurl1 = ''
                this.localSaleItem.imagethumburl1 = ''
            } 
            if(imagenumber=='image2'){
                this.localSaleItem.imageurl2 = ''
                this.localSaleItem.imagethumburl2 = ''
            } 
            if(imagenumber=='image3'){
                this.localSaleItem.imageurl3 = ''
                this.localSaleItem.imagethumburl3 = ''
            } 
            if(imagenumber=='image4'){
                this.localSaleItem.imageurl4 = ''
                this.localSaleItem.imagethumburl4 = ''
            } 
            if(imagenumber=='image5'){
                this.localSaleItem.imageurl5 = ''
                this.localSaleItem.imagethumburl5 = ''
            } 
            if(imagenumber=='image6'){
                this.localSaleItem.imageurl6 = ''
                this.localSaleItem.imagethumburl6 = ''
            }
            this.addItem(false)

        },

    },

    mounted(){
        console.log("Item = ")
        console.log(this.saleItem)
        this.localSaleItem = JSON.parse(JSON.stringify(this.saleItem));
        //convert price to number
        this.localSaleItem.price=parseFloat(this.localSaleItem.price)
    },
}
</script>

